module.exports = __webpack_public_path__ + "img/buy2get1.3454cca4.webp";